import styled from 'styled-components';

export const TanInputWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(6, auto);
  gap: 1rem;
  margin-top: 1rem;
`;

export const TanValidationError = styled.p`
  margin: 0.5rem 0 0 0;
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.baseColors.error};
`;

export const PhoneVerificationForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
